import { EntityUser } from "@features/user/types/user";

/**
 * Prefers an exact email match (case-insensitive); otherwise an exact TRN match.
 * Fuzzy directory hits that are not exact on either field return null.
 */
export function findExactInviteUserMatch(
    users: EntityUser[],
    email: string,
    trn: string
): EntityUser | null {
    const emailTrimmed = email.trim().toLowerCase();
    const trnTrimmed = trn.trim();

    if (emailTrimmed) {
        const byEmail = users.find((u) => (u.email ?? "").trim().toLowerCase() === emailTrimmed);
        if (byEmail) return byEmail;
    }

    if (trnTrimmed) {
        const byTrn = users.find((u) => (u.trn ?? "").trim() === trnTrimmed);
        if (byTrn) return byTrn;
    }

    return null;
}

/**
 * Freetext query for New-user directory match: prefer email when long enough,
 * else TRN when long enough.
 */
export function inviteNewUserMatchQuery(
    email: string,
    trn: string,
    minChars: number
): string {
    const emailTrimmed = email.trim();
    const trnTrimmed = trn.trim();
    if (emailTrimmed.length >= minChars) return emailTrimmed;
    if (trnTrimmed.length >= minChars) return trnTrimmed;
    return "";
}
